<template>
    <div class="transaction">
        <div class="transaction__data">
            <div class="transaction__data-left">
                <partner-logo class="logo"
                    :show-placeholder="true"
                    :url="transaction.logo.replace('~', '')"
                />
                <div class="transaction__infos">
                    <div class="transaction__infos--left">
                        <p :class="`transaction__status ${isProcessingClass(transaction.status)}`">
                            {{ transaction.status }}
                        </p>
                        <p class="transaction__type">
                            {{ transaction.transactionTypeName }}
                        </p>
                    </div>

                    <div class="transaction__date">
                        {{ formatDate(transaction.date) }}
                    </div>
                </div>
            </div>

            <div class="transaction__data-right">
                <div :class="`transaction__amount transaction__amount--${transaction.amountColor}`">{{ transaction.formattedAmount }}</div>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';
// Utils
import {
    format,
} from '@shared/utils/dates';

export default {
    name: 'transaction-card',
    components: {
        partnerLogo,

    },
    props: {
        transaction: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatDate(date) {
            return format(date, 'dd-MMM-yyyy');
        },

        isProcessingClass(status) {
            return status === 'Processing' ? 'with-processing' : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.transaction {
    border-bottom: 1px solid $athens-gray-color;
    padding: 1.8rem 0;

    &:last-child {
        border-bottom: 0;
    }

    .logo,
    .placeholder {
        width: 4.8rem;
        height: 4.8rem;
        align-self: center;
    }

    &__infos {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 2rem;

        @include max-width(sm) {
            flex-direction: column;
            gap: 0;
        }
    }

    &__data {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__data-left {
        display: flex;
        align-items: center;
        column-gap: 2rem;

        p {
            margin: 0;
        }
    }

    &__date {
        font-weight: 400;
        font-size: 11px;
        line-height: 15px;
        color: $daintree-color-t50;
    }

    &__status {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: $daintree-color-t50;

        .with-processing {
            color: $orange-peel-color;
        }
    }

    &__type {
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
        color: $daintree-color;
    }

    &__amount {
        font-size: 1.5rem;
        line-height: 2rem;
        font-weight: 600;
        padding-right: 0;

        &--amber {
            color: $pizazz-color;
        }

        &--green {
            color: $lima-color;
        }

        &--red {
            color: $monza-color;
        }
    }
}
</style>